<template>
  <div id="pass33">
    <v-card class="ep-rechner-box">
      <v-col cols="12" class="p-0">
        <div class="v-card__title p-0">
          <h2 class="v-card--head--title">
            {{ selectedLang.AirLineNotificationTile12 }}
          </h2>
        </div>
      </v-col>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <div class="v-card--msg">
              <h2 class="ep-rechner-h2">
                {{ selectedLang.AirLineNotificationTile13 }}
              </h2>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6">
            <p>{{ selectedLang.AirLineNotificationTile14 }}</p>
          </v-col>

          <v-col cols="12" sm="6">
            <v-select
              attach
              v-model="selectIn"
              :items="itemsBenachrichtigt"
              :disabled="pass33"
              item-text="state"
              :label="selectedLang.AirLineNotificationTile15"
              return-object
              persistent-hint
              single-line
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <p
              v-html="
                formatDBText(selectedLang.AirLineNotificationTile16, {
                  'this.flN': flN,
                })
              "
            ></p>
          </v-col>

          <v-col cols="12" sm="6">
            <v-select
              attach
              v-model="selectAl"
              :items="itemsJN"
              :disabled="pass33"
              item-text="state"
              return-object
              :label="selectedLang.AirLineNotificationTile17"
              persistent-hint
              single-line
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-row v-if="selectedDiv == '33'">
          <v-col cols="12">
            <v-btn
              id="confirm-notif-can"
              block
              :disabled="selectIn == '' || selectAl == ''"
              class="btn-ep-next-step"
              @click="check33"
              >{{ selectedLang.AirLineNotificationTile18 }}</v-btn
            >
          </v-col>
        </v-row>
        <v-row v-if="selectedDiv != '33' && !noChange">
          <v-col cols="12">
            <v-btn
              id="goto--notif-can"
              block
              class="btn-ep-back-to"
              @click="backToSpecificTile('33')"
              >{{ selectedLang.AirLineNotificationTile19 }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "AirlineNotificationTile",
  data: function () {
    return {
      selectIn: "",
      selectAl: "",
      itemsBenachrichtigt: [
        {
          val: "xx",
          state: this.$store.state.selectedLang.AirLineNotificationTile1,
        },
        {
          val: "weva",
          state: this.$store.state.selectedLang.AirLineNotificationTile2,
        },
        {
          val: "easf",
          state: this.$store.state.selectedLang.AirLineNotificationTile3,
        },
      ],
    };
  },
  computed: {
    ...mapState([
      "itemsJN",
      "pass33",
      "selectedDiv",
      "noChange",
      "selectedLang",
      "flN",
    ]),
  },
  methods: {
    ...mapActions([
      "backToSpecificTile",
      "goToStep",
      "setSelectedDiv",
      "setVar",
    ]),
    check33() {
      if (
        (this.selectIn.val == "weva" || this.selectIn.val == "easf") &&
        this.selectAl.val == "n"
      ) {
        this.setSelectedDiv("35");
        this.$nextTick(() => {
          this.goToStep({
            vm: this,
            val: this.selectedDiv,
            actPos: window.scrollY,
          });
        });
        this.setVar({ pos: "pass33", val: true });
      } else {
        if (this.selectAl.val == "y") {
          this.$store.state.rejectionMessage = this.formatDBText(
            this.$store.state.selectedLang.AirLineNotificationTile8,
            { "this.flN": this.flN }
          );
        }
        if (this.selectIn.val == "xx") {
          this.$store.state.rejectionMessage = this.formatDBText(
            this.$store.state.selectedLang.AirLineNotificationTile9,
            { "this.flN": this.flN }
          );
        }
        this.setSelectedDiv("32");
        this.$nextTick(() => {
          this.goToStep({
            vm: this,
            val: this.selectedDiv,
          });
        });
      }
      this.$store.state.dataEP.airlineNotification = this.selectIn.val;
      this.setVar({ pos: "selectIn", val: this.selectIn.state });
      this.setVar({ pos: "selectAl", val: this.selectAl.state });
      this.$gtag.event("4b. Zeitpunkt Annullierung benannt", {
        event_category: "Rechner",
        event_label: "4b. Zeitpunkt Annullierung benannt",
      });
    },
    formatDBText(str, values) {
      var result;
      var reg = /(\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
  },
};
</script>
